import { render, staticRenderFns } from "./MinusColumn.vue?vue&type=template&id=04e609a0&"
import script from "./MinusColumn.vue?vue&type=script&lang=js&"
export * from "./MinusColumn.vue?vue&type=script&lang=js&"
import style0 from "./MinusColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e609a0')) {
      api.createRecord('04e609a0', component.options)
    } else {
      api.reload('04e609a0', component.options)
    }
    module.hot.accept("./MinusColumn.vue?vue&type=template&id=04e609a0&", function () {
      api.rerender('04e609a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/column/MinusColumn.vue"
export default component.exports